import Nav from "components/layout/Nav";
import { TravelMenubar } from "components/layout/MenuBar";

const TourCMS = () => {
    return (
        <>
            <Nav />
            <div className="row">
                <TravelMenubar />
                <main style={{ width: "calc(100vw - 240px)", backgroundColor: "#D0D5DD" }}>
                        
                </main>
            </div>
        </>
    )
}

export default TourCMS;